/* VYBE — filtry zapachów, czytelne paski akordów, quiz „Znajdź swój VYBE”. */
(() => {
  /* Paski akordów: biały tekst na ciemnym kolorze, ciemny na jasnym (jak na Fragrantice). */
  const lum = (hex) => {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return 1;
    const n = parseInt(m[1], 16), c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };
  function initBars(root) {
    root.querySelectorAll('.vy-acc__bar[data-c]').forEach((b) => { if (lum(b.dataset.c) < 0.2) b.setAttribute('data-dark', ''); });
  }

  /* Filtry Warm / Fresh / Lux / Her (tagi produktów). */
  function initFilters(root) {
    root.querySelectorAll('[data-vy-scents]').forEach((sec) => {
      if (sec.dataset.vyReady) return; sec.dataset.vyReady = '1';
      const chips = [...sec.querySelectorAll('[data-vy-filter]')];
      const cards = [...sec.querySelectorAll('.vy-card')];
      chips.forEach((c) => c.addEventListener('click', () => {
        const tag = c.dataset.vyFilter;
        chips.forEach((x) => x.setAttribute('aria-pressed', String(x === c)));
        cards.forEach((card) => { card.hidden = !!tag && !card.dataset.tags.includes(',' + tag + ','); });
      }));
    });
  }

  /* Quiz: 3 pytania → wynik z akordów, pory i płci. */
  const Q = [
    { q: 'Kiedy najczęściej chcesz pachnieć?', key: 'when', opts: [
      { v: 'dzień', t: 'W dzień', s: 'praca, miasto, spotkania' },
      { v: 'wieczór', t: 'Wieczorem', s: 'kolacja, randka, wyjście' },
      { v: 'lato', t: 'Latem', s: 'słońce i ciepłe dni' },
      { v: 'zima', t: 'Zimą', s: 'chłód i długie wieczory' } ] },
    { q: 'Jaki klimat lubisz najbardziej?', key: 'vibe', opts: [
      { v: 'sweet', t: 'Słodko', s: 'wanilia, karmel, wiśnia' },
      { v: 'fresh', t: 'Świeżo', s: 'cytrusy, morze, zioła' },
      { v: 'wood', t: 'Drzewnie i dymnie', s: 'drewno, ambra, tytoń' },
      { v: 'fruit', t: 'Owocowo', s: 'soczyste owoce' } ] },
    { q: 'Dla kogo szukasz?', key: 'who', opts: [
      { v: 'm', t: 'Dla niego', s: '' },
      { v: 'f', t: 'Dla niej', s: '' },
      { v: 'u', t: 'Bez znaczenia', s: 'zapachy unisex też' },
      { v: 'gift', t: 'Na prezent', s: 'pewniak dla każdego' } ] },
  ];
  const VIBE = {
    sweet: ['wanilia', 'słodki', 'karmel', 'wiśnia', 'migdał', 'kakao', 'cynamon', 'pudrowy'],
    fresh: ['cytrusowy', 'świeże przyprawy', 'świeży', 'mineralny', 'wodny', 'ozonowy', 'zielony', 'ziołowy', 'aromatyczny', 'słony'],
    wood: ['drzewny', 'dymny', 'skórzany', 'ambrowy', 'tytoń', 'ciepłe przyprawy', 'piżmowy'],
    fruit: ['owocowy', 'wiśnia', 'tropikalny', 'cytrusowy'],
  };
  const score = (p, a) => {
    let s = 0;
    (p.acc || []).forEach(([n, w]) => { if ((VIBE[a.vibe] || []).includes(n)) s += w; });
    const pora = p.pora || '';
    if (a.when === 'dzień' && pora.includes('dzień')) s += 60;
    if (a.when === 'wieczór' && pora.includes('wieczór')) s += 60;
    if (a.when === 'lato' && (pora.includes('lato') || pora.includes('cały rok'))) s += 70;
    if (a.when === 'zima' && (pora.includes('zima') || pora.includes('cały rok'))) s += 70;
    const plec = (p.plec || 'Unisex').toLowerCase();
    if (a.who === 'm') s += plec === 'damskie' ? -400 : plec === 'męskie' ? 40 : 20;
    if (a.who === 'f') s += plec === 'męskie' ? -400 : plec === 'damskie' ? 60 : 30;
    if (a.who === 'gift' && (plec === 'unisex' || pora.includes('cały rok'))) s += 40;
    return s;
  };
  const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function initFinder(root) {
    root.querySelectorAll('[data-vy-finder]').forEach((box) => {
      if (box.dataset.vyReady) return; box.dataset.vyReady = '1';
      const dataEl = box.closest('section').querySelector('[data-vy-finder-data]');
      let items = [];
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const stage = box.querySelector('[data-vy-stage]');
      const back = box.querySelector('[data-vy-back]');
      const bars = [...box.querySelectorAll('.vy-finder__progress i')];
      const ans = {};
      let step = 0;
      const render = () => {
        bars.forEach((b, i) => b.classList.toggle('is-on', i <= step));
        back.hidden = step === 0;
        if (step < Q.length) {
          const q = Q[step];
          stage.innerHTML = `<p class="vy-finder__q">${q.q}</p><div class="vy-finder__opts">${q.opts.map((o) => `<button type="button" class="vy-opt" data-v="${o.v}">${o.t}${o.s ? `<span>${o.s}</span>` : ''}</button>`).join('')}</div>`;
          stage.querySelectorAll('.vy-opt').forEach((b) => b.addEventListener('click', () => { ans[q.key] = b.dataset.v; step += 1; render(); }));
          return;
        }
        const ranked = items.map((p) => ({ p, s: score(p, ans) })).sort((x, y) => y.s - x.s);
        const [best, ...rest] = ranked.map((r) => r.p);
        if (!best) { stage.innerHTML = '<p class="vy-finder__q">Brak zapachów do dopasowania.</p>'; return; }
        stage.innerHTML = `<div class="vy-finder__result">
          <p class="vy-finder__label">Twój VYBE</p>
          <a class="vy-finder__match" href="${esc(best.url)}"><img src="${esc(best.img)}" alt="" width="120" height="120" loading="lazy"><span><b>No. ${esc(best.nr)}</b><strong>${esc(best.name)}</strong><p>${esc(best.tag)}</p></span></a>
          <p class="vy-finder__label">Sprawdź też</p>
          <div class="vy-finder__alts">${rest.slice(0, 2).map((p) => `<a class="vy-finder__alt" href="${esc(p.url)}"><img src="${esc(p.img)}" alt="" width="48" height="48" loading="lazy"><span>No. ${esc(p.nr)} ${esc(p.name)}</span></a>`).join('')}</div>
          <button type="button" class="vy-finder__back" data-vy-again>↺ Zacznij od nowa</button>
        </div>`;
        stage.querySelector('[data-vy-again]').addEventListener('click', () => { step = 0; render(); });
      };
      back.addEventListener('click', () => { if (step > 0) { step -= 1; render(); } });
      render();
    });
  }

  /* Unboxing: przewijanie otwiera kostkę (0–40%), palec przeciąga po balsamie (40–70%), wychodzą chmurki akordów (70%+). */
  const mixHex = (a, b, t) => { const p = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16)); const A = p(a), B = p(b); return '#' + A.map((v, i) => Math.round(v + (B[i] - v) * t).toString(16).padStart(2, '0')).join(''); };
  const BALM = ['#D9BFA6', '#C9A07E', '#B98962', '#E3CDB6', '#A8734C', '#CDAE90', '#BE9672', '#DCC3A8', '#B07E58', '#C4997A'];
  function initAura(root) {
    root.querySelectorAll('[data-vy-aura]').forEach((sec) => {
      if (sec.dataset.vyReady) return; sec.dataset.vyReady = '1';
      let items = [];
      try { items = JSON.parse(sec.querySelector('[data-vy-aura-data]').textContent).filter((x) => x.acc && x.acc.length); } catch (e) { return; }
      if (!items.length) return;
      const lid = sec.querySelector('[data-vy-lid]'), balm = sec.querySelector('[data-vy-balm]'), swipe = sec.querySelector('[data-vy-swipe]');
      const clouds = sec.querySelector('[data-vy-clouds]'), picks = sec.querySelector('[data-vy-picks]');
      const nameEl = sec.querySelector('[data-vy-name]'), go = sec.querySelector('[data-vy-go]');
      const words = [...sec.querySelectorAll('.vy-aura__word span')];
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let cur = Math.min(4, items.length - 1);
      let last = -1, raf = 0;
      const place = (i) => { // chmurki dookoła kostki, większe = mocniejszy akord
        const it = items[i], n = Math.min(7, it.acc.length), small = innerWidth < 750;
        clouds.innerHTML = it.acc.slice(0, n).map(([name, w, c], k) => {
          const ang = (-150 + (k * 300) / Math.max(1, n - 1)) * Math.PI / 180;
          const r = (small ? 120 : 210) + (k % 2) * (small ? 26 : 44);
          const x = Math.round(Math.cos(ang) * r), y = Math.round(Math.sin(ang) * r * 0.78) - (small ? 40 : 60);
          const s = Math.round((small ? 54 : 84) + (w / 100) * (small ? 40 : 66));
          return `<div class="vy-aura__cloud" style="--c:${c};--s:${s}px;--x:${x}px;--y:${y}px;transition-delay:${k * 70}ms"><span>${esc(name)}</span></div>`;
        }).join('');
        balm.setAttribute('fill', BALM[i % BALM.length]);
        nameEl.innerHTML = `<small>No. ${esc(it.nr)}</small>${esc(it.name)}`;
        go.href = it.url;
        picks.querySelectorAll('button').forEach((b, k) => b.setAttribute('aria-pressed', String(k === i)));
      };
      picks.innerHTML = items.map((it, k) => `<button type="button" class="vy-aura__pick" style="--c:${it.acc[0][2]}" aria-label="No. ${esc(it.nr)} ${esc(it.name)}"><i></i>${esc(it.nr)}</button>`).join('');
      picks.querySelectorAll('button').forEach((b, k) => b.addEventListener('click', () => { cur = k; place(k); sec.classList.remove('is-open'); requestAnimationFrame(() => requestAnimationFrame(() => { if (last > 0.68 || reduce) sec.classList.add('is-open'); })); }));
      place(cur);
      const ease = (t) => t * t * (3 - 2 * t);
      const render = (p) => {
        const o = ease(Math.min(1, p / 0.38)); // otwieranie wieczka
        lid.setAttribute('transform', 'translate(' + (210 * o).toFixed(1) + ' ' + (-200 * o).toFixed(1) + ') rotate(' + (18 * o).toFixed(1) + ')');
        const sw = Math.max(0, Math.min(1, (p - 0.38) / 0.3)); // palec po balsamie
        swipe.style.opacity = sw > 0 && sw < 1 ? '1' : '0';
        swipe.setAttribute('cx', String(-120 + 240 * ease(sw)));
        sec.classList.toggle('is-open', p > 0.68);
        const wi = p < 0.36 ? 0 : p < 0.68 ? 1 : 2;
        words.forEach((w, i) => w.classList.toggle('is-on', i === wi));
        last = p;
      };
      if (reduce) { sec.classList.add('vy-aura--static'); render(1); return; }
      // animacja odtwarza się sama (ok. 3 s), gdy sekcja pojawi się na ekranie — bez przejmowania przewijania
      const play = (from = 0) => {
        cancelAnimationFrame(raf);
        const t0 = performance.now(), dur = 3000 * (1 - from);
        const step = (t) => { const p = Math.min(1, from + ((t - t0) / Math.max(1, dur)) * (1 - from)); render(p); if (p < 1) raf = requestAnimationFrame(step); };
        raf = requestAnimationFrame(step);
      };
      render(0);
      let played = false;
      new IntersectionObserver((en) => { if (en[0].isIntersecting && !played) { played = true; play(0); } }, { threshold: 0.45 }).observe(sec);
      addEventListener('resize', () => { place(cur); render(last < 0 ? 0 : last); });
    });
  }

  /* Kalkulator: cena flakonu → ile zapachów VYBE za tę kwotę. */
  const zl = (n) => new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 2 }).format(n);
  const plural = (n) => (n === 1 ? 'zapach' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'zapachy' : 'zapachów');
  function initCalc(root) {
    root.querySelectorAll('[data-vy-calc]').forEach((box) => {
      if (box.dataset.vyReady) return; box.dataset.vyReady = '1';
      const price = (parseInt(box.dataset.price, 10) || 12999) / 100;
      const colors = (box.dataset.colors || '').split(',').filter(Boolean);
      const range = box.querySelector('[data-vy-calc-range]'), val = box.querySelector('[data-vy-calc-val]');
      const out = box.querySelector('[data-vy-calc-out]'), dots = box.querySelector('[data-vy-calc-dots]');
      let shown = -1;
      const upd = () => {
        const v = parseInt(range.value, 10);
        const n = Math.floor(v / price);
        val.textContent = zl(v);
        const rest = Math.round((v - n * price) * 100) / 100;
        out.innerHTML = `Za tę kwotę masz <b>${n}</b> ${plural(n)} VYBE${n >= 2 ? ' zamiast jednego flakonu' : ''}${rest >= 5 ? ` — i zostaje Ci jeszcze ${zl(rest)} zł` : ''}.`;
        if (n !== shown) { shown = n; dots.innerHTML = Array.from({ length: Math.min(n, 40) }, (_, i) => `<i style="--c:${colors[i % (colors.length || 1)] || ''};animation-delay:${i * 18}ms"></i>`).join(''); }
      };
      range.addEventListener('input', upd);
      upd();
    });
  }

  /* Przyklejony pasek zakupu: widoczny, gdy główny przycisk zakupu zniknie z ekranu; klik = przycisk Horizon (koszyk), inaczej formularz. */
  function initSticky(root) {
    const bar = root.querySelector('[data-vy-sticky]');
    if (!bar || bar.dataset.vyReady) return; bar.dataset.vyReady = '1';
    const main = document.querySelector('.product-details [name="add"], .product-details add-to-cart-component, .product-details .buy-buttons-block, .product-details form[action*="/cart/add"]');
    const form = bar.querySelector('[data-vy-sticky-form]');
    const btn = form.querySelector('button');
    const show = (on) => { bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); btn.tabIndex = on ? 0 : -1; };
    if (main) new IntersectionObserver((en) => show(!en[0].isIntersecting && en[0].boundingClientRect.top < 0), { threshold: 0 }).observe(main);
    form.addEventListener('submit', (e) => {
      const real = document.querySelector('.product-details button[name="add"]:not([disabled]), .product-details add-to-cart-component button:not([disabled])');
      if (real) { e.preventDefault(); real.click(); }
    });
  }

  /* Baner: pudełka zmieniają się płynnie, poświata przyjmuje kolor zapachu, zdjęcia dociągane po kolei. */
  function initStage(root) {
    root.querySelectorAll('[data-vy-stage]:not([data-ok])').forEach((sec) => {
      sec.setAttribute('data-ok', '');
      const slides = [...sec.querySelectorAll('.vy-stage__slide')];
      const dots = [...sec.querySelectorAll('.vy-stage__dot')];
      const cap = sec.querySelector('.vy-stage__caption');
      if (!slides.length) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const every = +sec.dataset.interval || 4000;
      let i = 0, timer = null, widoczny = true;
      const laduj = (n) => { const img = slides[n % slides.length].querySelector('img[data-src]'); if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); } };
      const podpis = (s) => {
        sec.querySelector('[data-stage-nr]').textContent = s.dataset.nr || '';
        sec.querySelector('[data-stage-name]').textContent = s.dataset.name || '';
        sec.querySelector('[data-stage-tag]').textContent = s.dataset.tag || '';
      };
      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      const pokaz = (n) => {
        i = (n + slides.length) % slides.length;
        laduj(i); laduj(i + 1);
        slides.forEach((s, k) => { s.classList.toggle('is-on', k === i); s.tabIndex = k === i ? 0 : -1; });
        dots.forEach((d, k) => { d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', String(k === i)); });
        sec.style.setProperty('--sc', slides[i].dataset.c || '#A8734C');
        cap.classList.add('is-swap');
        setTimeout(() => { podpis(slides[i]); cap.classList.remove('is-swap'); }, 260);
      };
      const start = () => { stop(); if (!reduce && widoczny && !document.hidden) timer = setInterval(() => pokaz(i + 1), every); };
      dots.forEach((d) => d.addEventListener('click', () => { pokaz(+d.dataset.i); start(); }));
      sec.addEventListener('mouseenter', stop); sec.addEventListener('mouseleave', start);
      // strzałki oraz przesunięcie palcem albo przeciągnięcie myszką po scenie
      sec.querySelector('[data-stage-prev]')?.addEventListener('click', () => { pokaz(i - 1); start(); });
      sec.querySelector('[data-stage-next]')?.addEventListener('click', () => { pokaz(i + 1); start(); });
      const vis = sec.querySelector('.vy-stage__visual');
      let p0 = null, przesuniete = false;
      vis.addEventListener('pointerdown', (e) => { if (e.button !== 0 || e.target.closest('button')) return; p0 = { x: e.clientX, y: e.clientY }; przesuniete = false; });
      vis.addEventListener('pointerup', (e) => {
        if (!p0) return;
        const dx = e.clientX - p0.x, dy = e.clientY - p0.y; p0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { przesuniete = true; pokaz(i + (dx < 0 ? 1 : -1)); start(); }
      });
      vis.addEventListener('pointercancel', () => { p0 = null; });
      vis.addEventListener('dragstart', (e) => e.preventDefault());
      vis.addEventListener('click', (e) => { if (przesuniete) { e.preventDefault(); przesuniete = false; } }, true);
      sec.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { pokaz(i + 1); start(); } else if (e.key === 'ArrowLeft') { pokaz(i - 1); start(); } });
      new IntersectionObserver((en) => { widoczny = en[0].isIntersecting; if (widoczny) start(); else stop(); }, { threshold: 0.2 }).observe(sec);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      podpis(slides[0]); sec.style.setProperty('--sc', slides[0].dataset.c || '#A8734C');
      laduj(1);
      // po załadowaniu strony dociągnij resztę zdjęć w wolnej chwili
      const reszta = () => slides.forEach((s, k) => k && laduj(k));
      const poLoad = () => ('requestIdleCallback' in window ? requestIdleCallback(reszta, { timeout: 4000 }) : setTimeout(reszta, 2500));
      if (document.readyState === 'complete') poLoad(); else window.addEventListener('load', poLoad);
      start();
    });
  }

  /* Rzędy do przewijania (np. „Odkryj inne zapachy”): strzałki, przeciąganie myszką, palec działa natywnie. */
  function initSliders(root) {
    root.querySelectorAll('[data-vy-slider]:not([data-ok])').forEach((el) => {
      el.setAttribute('data-ok', '');
      const sec = el.closest('section') || el.parentElement;
      const prev = sec.querySelector('[data-vy-prev]'), next = sec.querySelector('[data-vy-next]');
      const krok = () => { const c = el.querySelector(':scope > *'); const gap = parseFloat(getComputedStyle(el).columnGap) || 12; return c ? (c.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(el.clientWidth / (c.getBoundingClientRect().width + gap))) : el.clientWidth * 0.8; };
      const stan = () => {
        const max = el.scrollWidth - el.clientWidth - 2;
        if (prev) prev.disabled = el.scrollLeft <= 2;
        if (next) next.disabled = el.scrollLeft >= max;
        const nav = sec.querySelector('[data-vy-slider-nav]');
        if (nav) nav.hidden = max <= 0;
      };
      prev?.addEventListener('click', () => el.scrollBy({ left: -krok(), behavior: 'smooth' }));
      next?.addEventListener('click', () => el.scrollBy({ left: krok(), behavior: 'smooth' }));
      el.addEventListener('scroll', () => requestAnimationFrame(stan), { passive: true });
      window.addEventListener('resize', stan);
      // przeciąganie myszką (telefon przewija sam)
      let d = null, ruszone = false;
      el.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button, input, select')) return;
        d = { x: e.clientX, l: el.scrollLeft }; ruszone = false;
      });
      window.addEventListener('pointermove', (e) => {
        if (!d) return;
        const dx = e.clientX - d.x;
        if (!ruszone && Math.abs(dx) > 6) { ruszone = true; el.classList.add('is-drag'); }
        if (ruszone) el.scrollLeft = d.l - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!d) return; d = null;
        if (ruszone) { el.classList.remove('is-drag'); const c = el.querySelector(':scope > *'); if (c) { const w = krok() / Math.max(1, Math.round(krok() / (c.getBoundingClientRect().width || 1))); el.scrollTo({ left: Math.round(el.scrollLeft / w) * w, behavior: 'smooth' }); } }
      });
      el.addEventListener('click', (e) => { if (ruszone) { e.preventDefault(); e.stopPropagation(); ruszone = false; } }, true);
      el.addEventListener('dragstart', (e) => e.preventDefault());
      stan();
    });
  }

  /* Płynne pojawianie się kolejnych sekcji przy przewijaniu. */
  function initReveal(root) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    root.querySelectorAll('main .shopify-section').forEach((s, n) => {
      if (n === 0 || s.offsetHeight < 10 || s.classList.contains('vy-rv') || s.getBoundingClientRect().top < window.innerHeight) return;
      s.classList.add('vy-rv'); io.observe(s);
    });
    setTimeout(() => root.querySelectorAll('.vy-rv:not(.is-in)').forEach((s) => s.classList.add('is-in')), 6000);
  }

  const init = (root = document) => { initBars(root); initFilters(root); initFinder(root); initAura(root); initCalc(root); initSticky(root); initStage(root); initSliders(root); initReveal(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
